<div class="multiple-editors-modal">
  <div class="modal-content">
    <p class="text-muted mb-4 text-start">
      Another user is currently in this file. If you click 'Save', their unsaved changes will be lost.
      <strong>Please connect with them before proceeding.</strong>
    </p>

    <div class="users-list mb-4">
      @for (user of users; track user) {
        <div class="user-item d-flex align-items-center mb-2">
          <div class="user-initials me-3" [title]="getFullName(user)">
            {{ getInitials(user) }}
          </div>
          <div class="user-info flex-grow-1">
            <div class="user-name fw-bold">{{ getFullName(user) }}</div>
            <div class="user-app text-muted small">via {{ getApplicationLabel(user) }}</div>
            <div class="user-timestamp text-muted small">Opened {{ getFormattedTimestamp(user) }}</div>
          </div>
        </div>
      }
    </div>

    <div class="d-flex justify-content-end gap-2">
      <button pButton type="button" label="Ok" (click)="close()" class="p-button-primary"></button>
    </div>
  </div>
</div>
